import produce from 'immer';
export var getInitialState = function () { return ({
    loading: false,
    updating: false,
    error: false,
    states: [],
    files: [],
    filesMeta: {},
}); };
function statesReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_STATES_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'LOAD_STATES_SUCCESS':
                state.loading = false;
                state.error = false;
                state.states = action.states || [];
                break;
            case 'LOAD_STATES_FAILURE':
                state.loading = false;
                state.error = true;
                state.states = [];
                break;
            case 'CREATE_STATE_REQUEST':
            case 'UPDATE_STATE_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'CREATE_STATE_SUCCESS':
            case 'UPDATE_STATE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.states = action.states || [];
                break;
            case 'CREATE_STATE_FAILURE':
            case 'UPDATE_STATE_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'DELETE_STATE_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'DELETE_STATE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.states = state.states.filter(function (l) { return l.id !== action.stateId; });
                break;
            case 'DELETE_STATE_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'STATE_LOAD_FILES_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'STATE_LOAD_FILES_SUCCESS':
                state.files = action.files || [];
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case 'STATE_LOAD_FILES_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default statesReducer;
